/**
 * TempoSupply – Side-Cart Footer: Bestellen + Warenkorb ansehen
 * Inline-Styles, weil Theme-Buttons über :before gerendert werden und
 * dynamisches async-CSS unsere Stylesheets überschreibt.
 */
(function () {
  var STYLE_ID = 'ts-side-cart-footer-js';

  function injectPseudoKillSheet() {
    if (document.getElementById(STYLE_ID)) {
      return;
    }

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent =
      '#cart.m6pn .sticky-in-panel .link-btn.wide{display:flex!important;flex-direction:row!important;flex-wrap:nowrap!important;align-items:center!important;gap:14px!important;width:100%!important;margin-right:0!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>*{float:none!important;width:auto!important;margin:0!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[name="checkout"],' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[data-live-checkout]{' +
      'order:1!important;flex:1 1 auto!important;display:inline-flex!important;align-items:center!important;justify-content:center!important;' +
      'background:#2ab3ca!important;background-color:#2ab3ca!important;background-image:none!important;' +
      'color:#fff!important;border:0!important;border-radius:var(--btn_br)!important;' +
      'box-shadow:0 2px 10px rgba(42,179,202,.28)!important;animation:none!important;-webkit-animation:none!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[name="checkout"]:before,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[name="checkout"]:after,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[data-live-checkout]:before,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[data-live-checkout]:after{' +
      'display:none!important;content:none!important;background:none!important;box-shadow:none!important;border:0!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[name="checkout"]:hover,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>button[data-live-checkout]:hover{' +
      'background:#239aab!important;background-color:#239aab!important;color:#fff!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a.overlay-tertiary,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a[href*="/cart"]{' +
      'order:2!important;flex:0 0 auto!important;display:inline-flex!important;align-items:center!important;align-self:center!important;' +
      'background:none!important;background-color:transparent!important;color:#185191!important;' +
      'font-size:14px!important;font-weight:600!important;text-decoration:underline!important;' +
      'text-underline-offset:3px!important;box-shadow:none!important;animation:none!important;-webkit-animation:none!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a.overlay-tertiary:before,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a.overlay-tertiary:after,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a[href*="/cart"]:before,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a[href*="/cart"]:after{' +
      'display:none!important;content:none!important;background:none!important;box-shadow:none!important}' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a.overlay-tertiary:hover,' +
      '#cart.m6pn .sticky-in-panel .link-btn.wide>a[href*="/cart"]:hover{' +
      'background:none!important;color:#2ab3ca!important}';

    document.body.appendChild(style);
  }

  function styleButton(btn) {
    if (!btn) {
      return;
    }

    var props = {
      order: '1',
      float: 'none',
      flex: '1 1 auto',
      display: 'inline-flex',
      'align-items': 'center',
      'justify-content': 'center',
      background: '#2ab3ca',
      'background-color': '#2ab3ca',
      'background-image': 'none',
      color: '#ffffff',
      border: '0',
      'border-radius': 'var(--btn_br)',
      'box-shadow': '0 2px 10px rgba(42, 179, 202, 0.28)',
      animation: 'none',
      '-webkit-animation': 'none',
      '--secondary_bg_btn': '#2ab3ca',
      '--tertiary_bg': '#2ab3ca'
    };

    Object.keys(props).forEach(function (key) {
      btn.style.setProperty(key, props[key], 'important');
    });
  }

  function styleLink(link, btnHeight) {
    if (!link) {
      return;
    }

    var props = {
      order: '2',
      float: 'none',
      flex: '0 0 auto',
      display: 'inline-flex',
      'align-items': 'center',
      'align-self': 'center',
      background: 'none',
      'background-color': 'transparent',
      color: '#185191',
      'font-size': '14px',
      'font-weight': '600',
      'text-decoration': 'underline',
      'text-underline-offset': '3px',
      'box-shadow': 'none',
      animation: 'none',
      '-webkit-animation': 'none',
      'min-height': btnHeight || '48px'
    };

    Object.keys(props).forEach(function (key) {
      link.style.setProperty(key, props[key], 'important');
    });
  }

  function ensureFooterRow(cart) {
    var row = cart.querySelector('.sticky-in-panel .link-btn.wide');
    if (row && row.querySelector('button[data-live-checkout], button[name="checkout"]')) {
      return row;
    }

    var form = cart.querySelector('.sticky-in-panel');
    if (!form) {
      return null;
    }

    var btn = form.querySelector(':scope > button[data-live-checkout], :scope > button[name="checkout"]');
    var link = form.querySelector(':scope > a[href*="/cart"]');
    if (!btn || !link) {
      return row;
    }

    var wrapper = document.createElement('div');
    wrapper.className = 'link-btn wide m10 ts-cart-footer-row';
    wrapper.setAttribute('data-ts-cart-footer-row', '1');
    link.parentNode.insertBefore(wrapper, link);
    wrapper.appendChild(link);
    wrapper.appendChild(btn);
    return wrapper;
  }

  function apply() {
    injectPseudoKillSheet();

    var cart = document.getElementById('cart');
    if (!cart) {
      return;
    }

    var row = ensureFooterRow(cart);
    var btn = row
      ? row.querySelector('button[name="checkout"], button[data-live-checkout]')
      : cart.querySelector(
          '.sticky-in-panel .link-btn.wide button[name="checkout"], .sticky-in-panel .link-btn.wide button[data-live-checkout]'
        );
    var link = row
      ? row.querySelector('a.overlay-tertiary, a[href*="/cart"]')
      : cart.querySelector(
          '.sticky-in-panel .link-btn.wide a.overlay-tertiary, .sticky-in-panel .link-btn.wide a[href*="/cart"]'
        );

    if (row) {
      row.style.setProperty('display', 'flex', 'important');
      row.style.setProperty('flex-direction', 'row', 'important');
      row.style.setProperty('flex-wrap', 'nowrap', 'important');
      row.style.setProperty('align-items', 'center', 'important');
      row.style.setProperty('gap', '14px', 'important');
      row.style.setProperty('width', '100%', 'important');
      row.style.setProperty('margin-right', '0', 'important');
    }

    styleButton(btn);

    var btnHeight = btn ? window.getComputedStyle(btn).minHeight : '48px';
    styleLink(link, btnHeight);

    if (btn && !btn.dataset.tsCartFooterBound) {
      btn.dataset.tsCartFooterBound = '1';
      btn.addEventListener('mouseenter', function () {
        btn.style.setProperty('background', '#239aab', 'important');
        btn.style.setProperty('background-color', '#239aab', 'important');
      });
      btn.addEventListener('mouseleave', function () {
        btn.style.setProperty('background', '#2ab3ca', 'important');
        btn.style.setProperty('background-color', '#2ab3ca', 'important');
      });
    }

    if (link && !link.dataset.tsCartFooterBound) {
      link.dataset.tsCartFooterBound = '1';
      link.addEventListener('mouseenter', function () {
        link.style.setProperty('color', '#2ab3ca', 'important');
      });
      link.addEventListener('mouseleave', function () {
        link.style.setProperty('color', '#185191', 'important');
      });
    }
  }

  function boot() {
    injectPseudoKillSheet();
    apply();

    window.addEventListener('listCart', apply);
    window.addEventListener('modulePanel', function () {
      window.setTimeout(apply, 0);
      window.setTimeout(apply, 100);
      window.setTimeout(apply, 400);
    });

    var cart = document.getElementById('cart');
    if (cart && window.MutationObserver) {
      new MutationObserver(function () {
        apply();
      }).observe(cart, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
